define(["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.getExtension = void 0;
    const getExtension = (viewer, extensionID) => {
        return new Promise((resolve, reject) => {
            let extension = viewer.getExtension(extensionID);
            if (extension) {
                resolve(extension);
            }
            else {
                viewer.addEventListener(Autodesk.Viewing.EXTENSION_LOADED_EVENT, (e) => {
                    if (e.extensionId === extensionID) {
                        resolve(viewer.getExtension(extensionID));
                    }
                });
            }
        });
    };
    exports.getExtension = getExtension;
});
//# sourceMappingURL=viewer.js.map